import { css } from '@emotion/core';

import { boxShadowGrey } from 'src/design-system/mixins';
import { Theme } from 'src/design-system/theme';

const restoreContainer = (offset: boolean) => (theme: Theme) =>
  css`
    width: 500px;
    @media (max-width: 600px) {
      width: 100%;
      right: 0;
      left: 0;
      bottom: 0;
    }
    position: fixed;
    bottom: ${offset ? '50px' : '0'};
    right: 16px;
    overflow: hidden;

    border-top-right-radius: 2px;
    border-top-left-radius: 2px;

    ${boxShadowGrey(2)}
    z-index: 100
  `;

const restoreProgress = (theme: Theme) => css`
  position: absolute;
  width: 100%;
  bottom: -10px;
  overflow: hidden;
  border-radius: 2px;

  > div {
    width: 100%;
  }
`;

const restoreProgressHeader = (theme: Theme) => css`
  background: #3f5efb;
  background: linear-gradient(42deg, rgba(63, 94, 251, 1) 0%, rgba(252, 70, 107, 1) 100%);
  align-items: center;
  justify-content: space-between;
`;

export const style = { restoreProgress, restoreContainer, restoreProgressHeader };
